import { ErrorResponse, Errors } from './Appointment/errors';

class HttpResponse<T> {
  public result: T;

  public error: Errors | ErrorResponse | undefined;

  public constructor(result: T, error?: Errors | ErrorResponse) {
    this.result = result;
    if (error) {
      this.error = error;
    }
  }
}

export default HttpResponse;
